/** Badge sort order on /badges. Device preference: localStorage only, never the DB. */
export type BadgeSort = 'name' | 'points-desc' | 'points-asc'

export const BADGE_SORTS: BadgeSort[] = ['name', 'points-desc', 'points-asc']
export const BADGE_SORT_STORAGE_KEY = 'badges-sort'
const DEFAULT_SORT: BadgeSort = 'name'

export const isBadgeSort = (v: unknown): v is BadgeSort =>
    v === 'name' || v === 'points-desc' || v === 'points-asc'

export const loadBadgeSort = (): BadgeSort => {
    try {
        const stored = localStorage.getItem(BADGE_SORT_STORAGE_KEY)
        return isBadgeSort(stored) ? stored : DEFAULT_SORT
    } catch {
        return DEFAULT_SORT
    }
}

export const persistBadgeSort = (sort: BadgeSort): void => {
    try {
        localStorage.setItem(BADGE_SORT_STORAGE_KEY, sort)
    } catch {
        // private window / quota: the choice lives for this session only
    }
}
